export default __webpack_public_path__ + "static/media/Icon-rota.912f3c5a.svg";